import React, {ReactElement} from 'react';
import {EventKind} from 'services/analytics';
import {RegisterAfterMount} from 'ui/adapters/Analytics';
import {Shout} from 'components/Text';
import {Section} from 'components/Section';

export const Failure = (): ReactElement => (
  <RegisterAfterMount event={EventKind.UserSpentEverything}>
    <Section data-test='failure-message'>
      <Shout color='red'>Потра&shy;че&shy;но</Shout>
    </Section>
  </RegisterAfterMount>
);
